
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sold-properties",
      function () {
        return require("private-next-pages/sold-properties.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sold-properties"])
      });
    }
  